var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-radio-group',{staticClass:"lz-currency-group",attrs:{"options":_vm.currencyOptions,"name":"radio-inline","buttons":"","button-variant":"outline-info","size":"sm"},on:{"change":_vm.currChange},model:{value:(_vm.selectedCurrency),callback:function ($$v) {_vm.selectedCurrency=$$v},expression:"selectedCurrency"}})
}
var staticRenderFns = []

export { render, staticRenderFns }